import { types as t, Instance } from 'mobx-state-tree';
import Syncable from '~/mst/models/abstract/syncable';
import CalibrationMeasurement from './measurement';

const CalibrationModel = t
  .compose(
    t.model({
      node_id: t.identifier,
      serial: t.string,
      measurements: t.maybeNull(t.array(CalibrationMeasurement)),
      // Device row: `calibrated` means "the most recent run passed on all four channels"
      // (calibrations.size == 4 && all calibrated), not "the device has calibration applied".
      // A device carrying good coefficients whose latest run failed reads false here.
      calibrated: t.boolean,
      ready: t.maybeNull(t.boolean),
      // Max applied-time across the device's records. On pre-deploy records it is the
      // end of the sampled window; the list keys status/sort on it either way.
      timestamp: t.maybeNull(t.number)
    }),
    Syncable
  )
  .named('Calibration');

export interface ICalibrationModel extends Instance<typeof CalibrationModel> {}

export default CalibrationModel;
